(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["binho-league"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('binho-league')) {
    customElements.define('binho-league', class extends HTMLElement {
      connectedCallback() {
        this.api = this.dataset.apiBase.replace(/\/$/, '');
        this.location = this.dataset.location;
        this.loggedIn = this.dataset.loggedIn === 'true';
        this.customerName = this.dataset.customerName;
        this.copy = JSON.parse(this.querySelector('[data-binho-copy]').textContent);
        this.data = null;
        this.bindTabs();
        this.bindForms();
        this.load();
      }

      bindTabs() {
        this.querySelectorAll('[data-binho-tab]').forEach((button) => {
          button.addEventListener('click', () => {
            const name = button.dataset.binhoTab;
            this.querySelectorAll('[data-binho-tab]').forEach((item) => item.classList.toggle('is-active', item === button));
            this.querySelectorAll('[data-binho-panel]').forEach((panel) => {
              const active = panel.dataset.binhoPanel === name;
              panel.classList.toggle('is-active', active);
              panel.hidden = !active;
            });
          });
        });
        this.querySelector('[data-binho-ranking]')?.addEventListener('change', (event) => this.renderLeaderboard(event.target.value));
      }

      bindForms() {
        this.querySelector('[data-binho-match-form]')?.addEventListener('submit', (event) => this.submitMatch(event));
        this.querySelector('[data-binho-event-form]')?.addEventListener('submit', (event) => this.submitEvent(event));
        this.addEventListener('click', (event) => {
          const action = event.target.closest('[data-match-action]');
          if (action) this.resolveMatch(action.dataset.matchId, action.dataset.matchAction);
        });
      }

      async load() {
        try {
          if (this.loggedIn && this.customerName) {
            await this.request('/profile', {
              method: 'POST',
              body: JSON.stringify({ display_name: this.customerName, location: this.location })
            });
          }
          this.data = await this.request(`/bootstrap?location=${encodeURIComponent(this.location)}`);
          this.render();
        } catch (error) {
          this.notice(error.message || this.copy.loadError);
        }
      }

      async request(path, options = {}) {
        const response = await fetch(`${this.api}${path}`, {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
          ...options
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || this.copy.loadError);
        return payload;
      }

      render() {
        this.querySelector('[data-binho-season]').textContent = this.data.season?.name || '—';
        this.renderLeaderboard(this.querySelector('[data-binho-ranking]').value);
        this.renderOpponents();
        this.renderPending();
        this.renderEvents();
        this.renderProfile();
        const admin = this.querySelector('[data-binho-event-form]');
        if (admin) admin.hidden = !this.data.viewer?.is_admin;
      }

      renderLeaderboard(sortKey = 'rating') {
        if (!this.data) return;
        const rows = [...this.data.leaderboard].sort((a, b) => Number(b[sortKey] || 0) - Number(a[sortKey] || 0));
        const body = this.querySelector('[data-binho-leaderboard]');
        if (!rows.length) {
          body.innerHTML = `<tr><td colspan="5">${this.esc(this.copy.emptyLeaderboard)}</td></tr>`;
          return;
        }
        body.innerHTML = rows.map((player, index) => `
          <tr>
            <td><span class="binho__rank">${index + 1}</span></td>
            <td><span class="binho__player"><span class="binho__avatar">${this.initials(player.display_name)}</span>${this.esc(player.display_name)}</span></td>
            <td><strong>${Number(player.rating).toFixed(0)}</strong></td>
            <td>${Number(player.career_wins)}–${Number(player.career_losses)}</td>
            <td>${Number(player.goals_for)}</td>
          </tr>
        `).join('');
      }

      renderOpponents() {
        const select = this.querySelector('[data-binho-opponents]');
        if (!select || !this.data.viewer) return;
        select.innerHTML = `<option value="">${this.esc(this.copy.selectOpponent)}</option>` + this.data.players
          .filter((player) => player.id !== this.data.viewer.id)
          .map((player) => `<option value="${this.esc(player.id)}">${this.esc(player.display_name)}</option>`)
          .join('');
      }

      renderPending() {
        const target = this.querySelector('[data-binho-pending]');
        if (!target) return;
        const pending = this.data.pending_matches || [];
        if (!pending.length) {
          target.textContent = this.copy.emptyPending;
          return;
        }
        target.innerHTML = pending.map((match) => `
          <div class="binho__pending">
            <div>
              <strong>${this.esc(match.reporter_name)} ${this.esc(this.copy.vs)} ${this.esc(match.opponent_name)}</strong>
              <div>${Number(match.reporter_score)}–${Number(match.opponent_score)}</div>
            </div>
            <div class="binho__pending-actions">
              <button class="binho__mini-button" type="button" data-match-id="${this.esc(match.id)}" data-match-action="confirm">${this.esc(this.copy.confirm)}</button>
              <button class="binho__mini-button" type="button" data-match-id="${this.esc(match.id)}" data-match-action="dispute">${this.esc(this.copy.dispute)}</button>
            </div>
          </div>
        `).join('');
      }

      renderEvents() {
        const target = this.querySelector('[data-binho-events]');
        const events = this.data.events || [];
        if (!events.length) {
          target.textContent = this.copy.emptyEvents;
          return;
        }
        target.innerHTML = events.map((event) => {
          const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(event.starts_at));
          return `<article class="binho__event"><time>${this.esc(date)}</time><strong>${this.esc(event.name)}</strong><span>${this.esc(event.format_label)}</span></article>`;
        }).join('');
      }

      renderProfile() {
        const target = this.querySelector('[data-binho-profile]');
        if (!target || !this.data.viewer) return;
        const player = this.data.viewer;
        const total = Number(player.career_wins) + Number(player.career_losses);
        const winPercent = total ? Math.round((Number(player.career_wins) / total) * 100) : 0;
        target.innerHTML = `
          <p class="binho__kicker">${this.esc(this.copy.rating)} ${Number(player.rating).toFixed(0)}</p>
          <h2>${this.esc(player.display_name)}</h2>
          <div class="binho__stats">
            ${this.stat(this.copy.record, `${Number(player.career_wins)}–${Number(player.career_losses)}`)}
            ${this.stat(this.copy.winPercent, `${winPercent}%`)}
            ${this.stat(this.copy.goals, Number(player.goals_for))}
            ${this.stat(this.copy.seasonPoints, Number(player.season_points))}
            ${this.stat(this.copy.tournamentPoints, Number(player.tournament_points))}
            ${this.stat(this.copy.championships, Number(player.championships))}
          </div>
        `;
      }

      stat(label, value) {
        return `<div class="binho__stat"><span>${this.esc(label)}</span><strong>${this.esc(value)}</strong></div>`;
      }

      async submitMatch(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const values = Object.fromEntries(new FormData(form));
        const viewer = Number(values.viewer_score);
        const opponent = Number(values.opponent_score);
        if (viewer === opponent || Math.max(viewer, opponent) !== 7 || Math.min(viewer, opponent) < 0) {
          this.notice(this.copy.invalidScore);
          return;
        }
        const button = form.querySelector('button[type="submit"]');
        button.disabled = true;
        button.textContent = this.copy.saving;
        try {
          await this.request('/matches', {
            method: 'POST',
            body: JSON.stringify({
              opponent_id: values.opponent_id,
              viewer_score: viewer,
              opponent_score: opponent,
              location: this.location
            })
          });
          form.reset();
          this.notice(this.copy.matchSubmitted);
          await this.load();
        } catch (error) {
          this.notice(error.message);
        } finally {
          button.disabled = false;
          button.textContent = this.copy.matchSubmitted.replace(/[.!]$/, '');
        }
      }

      async resolveMatch(id, action) {
        try {
          await this.request(`/matches/${encodeURIComponent(id)}/${action}`, { method: 'POST', body: '{}' });
          this.notice(action === 'confirm' ? this.copy.matchConfirmed : this.copy.matchDisputed);
          await this.load();
        } catch (error) {
          this.notice(error.message);
        }
      }

      async submitEvent(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const values = Object.fromEntries(new FormData(form));
        try {
          await this.request('/admin/events', {
            method: 'POST',
            body: JSON.stringify({ ...values, location: this.location })
          });
          form.reset();
          this.notice(this.copy.eventCreated);
          await this.load();
        } catch (error) {
          this.notice(error.message);
        }
      }

      notice(message) {
        const notice = this.querySelector('[data-binho-notice]');
        notice.textContent = message;
        notice.hidden = false;
        clearTimeout(this.noticeTimer);
        this.noticeTimer = setTimeout(() => { notice.hidden = true; }, 6000);
      }

      initials(name) {
        return String(name || '?').split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
      }

      esc(value) {
        const node = document.createElement('div');
        node.textContent = String(value ?? '');
        return node.innerHTML;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["release-calendar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('release-calendar')) {
    class ReleaseCalendar extends HTMLElement {
      connectedCallback() {
        if (this.initialized || !this.dataset.calendarId || !this.dataset.apiKey) return;
        this.initialized = true;
        this.app = this.querySelector('.release-calendar__app');
        this.today = new Date();
        this.viewDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
        this.selectedDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
        this.mobileView = 'month';
        this.activeCategory = 'all';
        this.events = [];
        this.productImages = new Map();
        this.collectionImages = new Map();
        this.brandLogos = Array.from(this.querySelectorAll('[data-brand-logo]'))
          .map((logo) => ({ name: logo.dataset.brandName, image: logo.dataset.brandImage }))
          .filter((logo) => logo.name && logo.image)
          .sort((a, b) => b.name.length - a.name.length);
        this.labels = {
          all: this.dataset.labelAll,
          disc: this.dataset.labelDisc,
          apparel: this.dataset.labelApparel,
          merch: this.dataset.labelMerch,
          restock: this.dataset.labelRestock,
          event: this.dataset.labelEvent,
          add: this.dataset.labelAdd,
          google: this.dataset.labelGoogle,
          ics: this.dataset.labelIcs,
          copy: this.dataset.labelCopy,
          copied: this.dataset.labelCopied,
          today: this.dataset.labelToday,
          empty: this.dataset.labelEmpty,
          loading: this.dataset.labelLoading,
          error: this.dataset.labelError,
          upcoming: this.dataset.labelUpcoming,
          categories: this.dataset.labelCategories,
          previous: this.dataset.labelPrevious,
          next: this.dataset.labelNext,
          close: this.dataset.labelClose,
          more: this.dataset.labelMore,
          products: this.dataset.labelProducts,
          productsHeading: this.dataset.labelProductsHeading,
          details: this.dataset.labelDetails,
          viewCollection: this.dataset.labelViewCollection,
          viewFullCalendar: this.dataset.labelViewFullCalendar,
          backToMonth: this.dataset.labelBackToMonth
        };
        this.categoryColors = {
          disc: '#f7342f',
          apparel: '#8b5cf6',
          merch: '#f59e0b',
          restock: '#0ea5e9',
          event: '#10b981'
        };
        this.loadEvents();
      }

      async loadEvents(centerDate = this.viewDate) {
        this.setLoading();
        const monthsAhead = Number(this.dataset.monthsAhead || 12);
        const start = new Date(centerDate.getFullYear(), centerDate.getMonth() - 2, 1);
        const end = new Date(centerDate.getFullYear(), centerDate.getMonth() + monthsAhead + 1, 1);
        const params = new URLSearchParams({
          key: this.dataset.apiKey,
          timeMin: start.toISOString(),
          timeMax: end.toISOString(),
          singleEvents: 'true',
          orderBy: 'startTime',
          maxResults: '2500'
        });
        const calendarId = encodeURIComponent(this.dataset.calendarId);
        const url = `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?${params}`;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Calendar request failed: ${response.status}`);
          const payload = await response.json();
          this.events = (payload.items || [])
            .filter((item) => item.status !== 'cancelled' && item.start)
            .map((item) => this.normalizeEvent(item))
            .sort((a, b) => a.start - b.start);
          this.loadedStart = start;
          this.loadedEnd = end;
          this.render();
          this.hydrateProducts();
        } catch (error) {
          console.error('[Release calendar]', error);
          this.app.innerHTML = `<div class="release-calendar__error" role="alert">${this.escape(this.labels.error)}</div>`;
        }
      }

      setLoading() {
        this.app.innerHTML = `<div class="release-calendar__loading"><span class="release-calendar__spinner" aria-hidden="true"></span><span>${this.escape(this.labels.loading)}</span></div>`;
      }

      normalizeEvent(item) {
        const rawDescription = item.description || '';
        const allDay = Boolean(item.start.date);
        const startRaw = item.start.dateTime || `${item.start.date}T00:00:00`;
        const endRaw = item.end?.dateTime || `${item.end?.date || item.start.date}T00:00:00`;
        const meta = this.parseDescription(rawDescription);
        const products = this.extractProducts(rawDescription);
        let collection = this.extractCollection(rawDescription);
        const imageUrl = this.metadataUrl(rawDescription, 'image') || this.firstLink(meta.image) || this.firstUrl(this.plainText(meta.image));
        const metadataLink = this.metadataUrl(rawDescription, 'collection') || this.metadataUrl(rawDescription, 'link') || this.metadataUrl(rawDescription, 'product') || this.firstLink(meta.link) || this.firstUrl(this.plainText(meta.link));
        if (metadataLink && this.isProductUrl(metadataLink) && !products.some((product) => product.url === metadataLink)) {
          products.push({ title: '', url: metadataLink, imageUrl: '' });
        }
        if (metadataLink && this.isCollectionUrl(metadataLink) && !collection) {
          collection = { title: '', url: metadataLink, imageUrl: '' };
        }
        const cleanDescription = this.cleanEventDescription(meta.description, products, imageUrl, collection);
        const categoryMatch = (item.summary || '').match(/^\s*\[(disc|apparel|merch|restock|event)\]\s*/i);
        const category = (meta.category || categoryMatch?.[1] || 'disc').toLowerCase();
        const safeCategory = this.categoryColors[category] ? category : 'disc';
        const title = (item.summary || 'Untitled release').replace(/^\s*\[[^\]]+\]\s*/, '').trim();

        return {
          id: item.id,
          uid: item.iCalUID || item.id,
          title,
          category: safeCategory,
          start: new Date(startRaw),
          end: new Date(endRaw),
          startRaw: item.start.dateTime || item.start.date,
          endRaw: item.end?.dateTime || item.end?.date || item.start.date,
          allDay,
          description: cleanDescription,
          products,
          collection,
          imageUrl,
          location: item.location || '',
          sourceUrl: item.htmlLink || ''
        };
      }

      parseDescription(description) {
        const meta = { category: '', link: '', image: '', description: '' };
        const content = [];
        description.split(/\r?\n/).forEach((line) => {
          const match = line.match(/^\s*(category|link|product|image)\s*:\s*(.+)\s*$/i);
          if (!match) {
            content.push(line);
            return;
          }
          const key = match[1].toLowerCase();
          if (key === 'category') meta.category = match[2].trim();
          if (key === 'link' || key === 'product') meta.link = match[2].trim();
          if (key === 'image') meta.image = match[2].trim();
        });
        meta.description = content.join('\n').trim();
        return meta;
      }

      firstUrl(text) {
        return text.match(/https?:\/\/[^\s<]+/i)?.[0]?.replace(/[),.;]+$/, '') || '';
      }

      firstLink(html) {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        return documentFragment.querySelector('a[href]')?.href || '';
      }

      metadataUrl(html, key) {
        const separators = '(?:\\s|<br\\s*\\/?>|<\\/?(?:div|p)[^>]*>)*';
        const pattern = new RegExp(`${key}\\s*:?${separators}(?:<a[^>]*href=["']([^"']+)["'][^>]*>|(https?:\\/\\/[^\\s<]+))`, 'i');
        const match = html.match(pattern);
        if (!match) return '';
        const documentFragment = new DOMParser().parseFromString(`<a href="${match[1] || match[2]}"></a>`, 'text/html');
        return documentFragment.querySelector('a')?.href || '';
      }

      plainText(html) {
        const withLineBreaks = html
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<\/p>/gi, '\n');
        const documentFragment = new DOMParser().parseFromString(withLineBreaks, 'text/html');
        return (documentFragment.body.textContent || '')
          .replace(/\n{3,}/g, '\n\n')
          .trim();
      }

      isProductUrl(value) {
        try {
          return new URL(value, window.location.origin).pathname.includes('/products/');
        } catch (error) {
          return false;
        }
      }

      isCollectionUrl(value) {
        try {
          return new URL(value, window.location.origin).pathname.includes('/collections/');
        } catch (error) {
          return false;
        }
      }

      extractProducts(html) {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const products = [];
        documentFragment.querySelectorAll('a[href]').forEach((anchor) => {
          const url = anchor.href;
          if (!this.isProductUrl(url) || products.some((product) => product.url === url)) return;
          const title = anchor.textContent.trim();
          products.push({
            title: title === url ? '' : title,
            url,
            imageUrl: ''
          });
        });
        return products;
      }

      extractCollection(html) {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const anchor = Array.from(documentFragment.querySelectorAll('a[href]'))
          .find((item) => this.isCollectionUrl(item.href));
        if (!anchor) return null;
        const title = anchor.textContent.trim();
        return {
          title: title === anchor.href ? '' : title,
          url: anchor.href,
          imageUrl: ''
        };
      }

      cleanEventDescription(html, products, imageUrl = '', collection = null) {
        const productTitles = products.map((product) => product.title).filter(Boolean);
        return this.plainText(html)
          .split('\n')
          .map((line) => line.trim())
          .filter((line) => line)
          .filter((line) => !/^products?\s*:?$/i.test(line))
          .filter((line) => !/^(image|link|product|collection|category)\s*:/i.test(line))
          .filter((line) => !imageUrl || line !== imageUrl)
          .filter((line) => !productTitles.includes(line))
          .filter((line) => !products.some((product) => line === product.url))
          .filter((line) => !collection || line !== collection.title)
          .filter((line) => !collection || line !== collection.url)
          .join('\n')
          .trim();
      }

      render() {
        if (this.dataset.layout === 'upcoming') {
          this.renderUpcomingOnly();
          return;
        }

        this.app.innerHTML = `
          ${this.filtersMarkup()}
          <div class="release-calendar__desktop">
            ${this.toolbarMarkup()}
            <div class="release-calendar__desktop-layout">
              ${this.monthMarkup()}
              <aside class="release-calendar__sidebar">
                <h3 class="release-calendar__sidebar-title">${this.escape(this.labels.upcoming)}</h3>
                <div class="release-calendar__cards">${this.upcomingCardsMarkup(6)}</div>
              </aside>
            </div>
          </div>
          <div class="release-calendar__mobile">
            ${this.mobileView === 'day' ? this.mobileDayMarkup() : `${this.toolbarMarkup()}${this.monthMarkup(true)}`}
          </div>
          ${this.modalMarkup()}
        `;
        this.bindEvents();
      }

      renderUpcomingOnly() {
        this.app.innerHTML = `
          ${this.filtersMarkup()}
          ${this.carouselMarkup(Number(this.dataset.eventLimit || 6))}
          ${this.fullCalendarLinkMarkup()}
          ${this.modalMarkup()}
        `;
        this.bindEvents();
      }

      filtersMarkup() {
        return `<div class="release-calendar__filters" aria-label="${this.escape(this.labels.categories)}">
          ${['all', 'disc', 'apparel', 'merch', 'restock', 'event'].map((category) => `
            <button class="release-calendar__filter" type="button" data-category="${category}" aria-pressed="${this.activeCategory === category}">${this.escape(this.labels[category])}</button>
          `).join('')}
        </div>`;
      }

      toolbarMarkup() {
        const title = new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' }).format(this.viewDate);
        return `<div class="release-calendar__toolbar">
          <div class="release-calendar__month-nav">
            <button class="release-calendar__icon-button" type="button" data-action="previous" aria-label="${this.escape(this.labels.previous)}">${this.chevron('left')}</button>
            <h3 class="release-calendar__month-title">${this.escape(title)}</h3>
            <button class="release-calendar__icon-button" type="button" data-action="next" aria-label="${this.escape(this.labels.next)}">${this.chevron('right')}</button>
          </div>
          <button class="release-calendar__today" type="button" data-action="today">${this.escape(this.labels.today)}</button>
        </div>`;
      }

      monthMarkup(isMobile = false) {
        const weekdays = Array.from({ length: 7 }, (_, index) => {
          const date = new Date(2024, 0, 7 + index);
          return new Intl.DateTimeFormat(undefined, { weekday: 'short' }).format(date);
        });
        const first = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1);
        const gridStart = new Date(first);
        gridStart.setDate(first.getDate() - first.getDay());
        const cells = [];

        for (let index = 0; index < 42; index += 1) {
          const date = new Date(gridStart);
          date.setDate(gridStart.getDate() + index);
          const dayEvents = this.eventsForDate(date).slice(0, 3);
          const total = this.eventsForDate(date).length;
          const outside = date.getMonth() !== this.viewDate.getMonth();
          const today = this.sameDay(date, this.today);
          const mobileAttributes = isMobile
            ? ` role="button" tabindex="0" data-mobile-date="${this.dateKey(date)}" aria-label="${this.escape(new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(date))}, ${total} ${this.escape(this.labels.products)}"`
            : '';
          cells.push(`<div class="release-calendar__day${outside ? ' release-calendar__day--outside' : ''}${today ? ' release-calendar__day--today' : ''}"${mobileAttributes}>
            <span class="release-calendar__date">${date.getDate()}</span>
            ${dayEvents.map((event) => this.eventPillMarkup(event)).join('')}
            ${total > 3 ? `<p class="release-calendar__more">+${total - 3} ${this.escape(this.labels.more)}</p>` : ''}
          </div>`);
        }

        return `<div class="release-calendar__month">
          <div class="release-calendar__weekdays">${weekdays.map((day) => `<div class="release-calendar__weekday">${this.escape(day)}</div>`).join('')}</div>
          <div class="release-calendar__grid">${cells.join('')}</div>
        </div>`;
      }

      eventPillMarkup(event) {
        const time = event.allDay ? '' : new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(event.start);
        return `<button class="release-calendar__event-pill" type="button" data-event-id="${this.escape(event.id)}" style="--event-color: ${this.categoryColors[event.category]}">${time ? `${this.escape(time)} · ` : ''}${this.escape(event.title)}</button>`;
      }

      agendaMarkup() {
        const monthStart = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1);
        const monthEnd = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 1);
        const events = this.filteredEvents().filter((event) => event.start >= monthStart && event.start < monthEnd);
        if (!events.length) return `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`;

        const groups = new Map();
        events.forEach((event) => {
          const key = this.dateKey(event.start);
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key).push(event);
        });

        return Array.from(groups.entries()).map(([key, dayEvents]) => {
          const date = new Date(`${key}T12:00:00`);
          const heading = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(date);
          return `<h3 class="release-calendar__agenda-heading">${this.escape(heading)}</h3>${dayEvents.map((event) => this.cardMarkup(event)).join('')}`;
        }).join('');
      }

      upcomingCardsMarkup(limit) {
        const now = new Date();
        const events = this.filteredEvents().filter((event) => event.end >= now).slice(0, limit);
        if (!events.length) return `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`;
        return events.map((event) => this.cardMarkup(event)).join('');
      }

      carouselMarkup(limit) {
        const now = new Date();
        const events = this.filteredEvents().filter((event) => event.end >= now).slice(0, limit);
        if (!events.length) return `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`;
        return `<div class="release-calendar__carousel" data-carousel>
          <div class="release-calendar__carousel-header">
            <h3 class="release-calendar__carousel-title">${this.escape(this.labels.upcoming)}</h3>
            <div class="release-calendar__carousel-controls">
              <button class="release-calendar__icon-button" type="button" data-carousel-action="previous" aria-label="${this.escape(this.labels.previous)}">${this.chevron('left')}</button>
              <button class="release-calendar__icon-button" type="button" data-carousel-action="next" aria-label="${this.escape(this.labels.next)}">${this.chevron('right')}</button>
            </div>
          </div>
          <div class="release-calendar__carousel-track" data-carousel-track>
            ${events.map((event) => this.cardMarkup(event, 'carousel')).join('')}
          </div>
        </div>`;
      }

      fullCalendarLinkMarkup() {
        if (!this.dataset.fullCalendarUrl) return '';
        return `<div class="release-calendar__full-link-wrap">
          <a class="release-calendar__full-link" href="${this.escape(this.dataset.fullCalendarUrl)}">
            ${this.escape(this.labels.viewFullCalendar)} <span class="release-calendar__full-link-arrow" aria-hidden="true">→</span>
          </a>
        </div>`;
      }

      mobileDayMarkup() {
        const heading = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(this.selectedDate);
        const events = this.eventsForDate(this.selectedDate);
        return `<div class="release-calendar__mobile-day" data-mobile-day-view>
          <div class="release-calendar__mobile-day-header">
            <button class="release-calendar__icon-button" type="button" data-day-action="previous" aria-label="${this.escape(this.labels.previous)}">${this.chevron('left')}</button>
            <h3 class="release-calendar__mobile-day-title">${this.escape(heading)}</h3>
            <button class="release-calendar__icon-button" type="button" data-day-action="next" aria-label="${this.escape(this.labels.next)}">${this.chevron('right')}</button>
          </div>
          <div class="release-calendar__mobile-day-cards" data-mobile-day-swipe>
            ${events.length ? events.map((event) => this.cardMarkup(event)).join('') : `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`}
          </div>
          <button class="release-calendar__back-to-month" type="button" data-action="back-to-month">${this.escape(this.labels.backToMonth)}</button>
        </div>`;
      }

      cardMarkup(event, variant = 'compact') {
        const hasImage = this.dataset.showImages === 'true' && event.imageUrl;
        const date = new Intl.DateTimeFormat(undefined, {
          weekday: 'short', month: 'short', day: 'numeric',
          ...(event.allDay ? {} : { hour: 'numeric', minute: '2-digit' })
        }).format(event.start);
        return `<article class="release-calendar__card release-calendar__card--${variant}${hasImage ? '' : ' release-calendar__card--no-image'}" data-event-card data-event-id="${this.escape(event.id)}" style="--event-color: ${this.categoryColors[event.category]}">
          ${hasImage ? `<img class="release-calendar__card-image${event.brandLogo ? ' release-calendar__card-image--brand' : ''}" src="${this.escape(event.imageUrl)}" alt="" width="188" height="188" loading="lazy">` : ''}
          <div class="release-calendar__card-content">
            <span class="release-calendar__category">${this.escape(this.labels[event.category])}</span>
            <h3 class="release-calendar__card-title">${this.escape(event.title)}</h3>
            <p class="release-calendar__card-time">${this.escape(date)}</p>
            ${event.products.length ? `<p class="release-calendar__card-time">${event.products.length} ${this.escape(this.labels.products)}</p>` : ''}
            <div class="release-calendar__card-actions">
              <button class="release-calendar__button" type="button" data-event-id="${this.escape(event.id)}">${this.escape(variant === 'carousel' ? this.labels.details : this.labels.add)}</button>
            </div>
          </div>
        </article>`;
      }

      modalMarkup() {
        return `<div class="release-calendar__modal" hidden>
          <div class="release-calendar__modal-backdrop" data-action="close"></div>
          <div class="release-calendar__modal-panel" role="dialog" aria-modal="true" aria-labelledby="ReleaseCalendarModalTitle-${this.dataset.sectionId}">
            <button class="release-calendar__icon-button release-calendar__modal-close" type="button" data-action="close" aria-label="${this.escape(this.labels.close)}">&times;</button>
            <div class="release-calendar__modal-content"></div>
          </div>
        </div>`;
      }

      openModal(event) {
        const modal = this.querySelector('.release-calendar__modal');
        const content = modal.querySelector('.release-calendar__modal-content');
        const googleUrl = this.googleCalendarUrl(event);
        content.innerHTML = `
          <span class="release-calendar__category release-calendar__modal-category" style="--event-color: ${this.categoryColors[event.category]}; color: ${this.categoryColors[event.category]}">${this.escape(this.labels[event.category])}</span>
          <h3 class="release-calendar__modal-title" id="ReleaseCalendarModalTitle-${this.dataset.sectionId}">${this.escape(event.title)}</h3>
          <p class="release-calendar__modal-time">${this.escape(this.longDate(event))}</p>
          ${event.description ? `<div class="release-calendar__modal-description">${this.escape(event.description)}</div>` : ''}
          ${this.productListMarkup(event)}
          <div class="release-calendar__modal-actions">
            <a class="release-calendar__modal-button" href="${this.escape(googleUrl)}" target="_blank" rel="noopener">${this.escape(this.labels.google)}</a>
            <button class="release-calendar__modal-button release-calendar__modal-button--secondary" type="button" data-action="ics">${this.escape(this.labels.ics)}</button>
            <button class="release-calendar__modal-button release-calendar__modal-button--secondary" type="button" data-action="copy">${this.escape(this.labels.copy)}</button>
            ${event.collection ? `<a class="release-calendar__modal-button release-calendar__modal-button--secondary" href="${this.escape(event.collection.url)}">${this.escape(this.labels.viewCollection)}</a>` : ''}
          </div>`;
        modal.hidden = false;
        modal.dataset.eventId = event.id;
        document.body.classList.add('release-calendar-modal-open');
        modal.querySelector('[data-action="close"]').focus();
      }

      productListMarkup(event) {
        if (!event.products.length) return '';
        return `<div class="release-calendar__product-list">
          <h4 class="release-calendar__product-list-title">${this.escape(this.labels.productsHeading)}</h4>
          ${event.products.map((product) => `
            <a class="release-calendar__product-item" href="${this.escape(product.url)}">
              ${product.imageUrl
                ? `<img class="release-calendar__product-image" src="${this.escape(product.imageUrl)}" alt="" width="116" height="116" loading="lazy">`
                : '<span class="release-calendar__product-placeholder" aria-hidden="true"></span>'}
              <span class="release-calendar__product-name">${this.escape(product.title || 'View product')}</span>
              <span class="release-calendar__product-arrow" aria-hidden="true">›</span>
            </a>
          `).join('')}
        </div>`;
      }

      closeModal() {
        const modal = this.querySelector('.release-calendar__modal');
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('release-calendar-modal-open');
      }

      bindEvents() {
        this.querySelectorAll('[data-category]').forEach((button) => {
          button.addEventListener('click', () => {
            this.activeCategory = button.dataset.category;
            this.render();
          });
        });
        this.querySelectorAll('[data-event-id]').forEach((element) => {
          if (element.tagName === 'A') return;
          element.addEventListener('click', (clickEvent) => {
            if (element.hasAttribute('data-event-card') && clickEvent.target.closest('a, button')) return;
            const event = this.events.find((item) => item.id === element.dataset.eventId);
            if (event) this.openModal(event);
          });
        });
        this.querySelectorAll('[data-carousel-action]').forEach((button) => {
          button.addEventListener('click', () => {
            const carousel = button.closest('[data-carousel]');
            const track = carousel?.querySelector('[data-carousel-track]');
            const card = track?.querySelector('.release-calendar__card');
            if (!track || !card) return;
            const gap = Number.parseFloat(getComputedStyle(track).gap) || 16;
            const distance = card.getBoundingClientRect().width + gap;
            track.scrollBy({
              left: button.dataset.carouselAction === 'next' ? distance : -distance,
              behavior: 'smooth'
            });
          });
        });
        this.querySelectorAll('[data-mobile-date]').forEach((day) => {
          const openDay = () => {
            this.selectedDate = this.dateFromKey(day.dataset.mobileDate);
            this.mobileView = 'day';
            this.render();
          };
          day.addEventListener('click', (event) => {
            if (event.target.closest('[data-event-id]')) return;
            openDay();
          });
          day.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openDay();
            }
          });
        });
        this.querySelectorAll('[data-day-action]').forEach((button) => {
          button.addEventListener('click', () => this.changeSelectedDay(button.dataset.dayAction === 'next' ? 1 : -1));
        });
        this.querySelector('[data-action="back-to-month"]')?.addEventListener('click', () => {
          this.mobileView = 'month';
          this.viewDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
          this.render();
        });
        const swipeArea = this.querySelector('[data-mobile-day-swipe]');
        if (swipeArea) {
          let touchStartX = 0;
          let touchStartY = 0;
          swipeArea.addEventListener('touchstart', (event) => {
            touchStartX = event.changedTouches[0].clientX;
            touchStartY = event.changedTouches[0].clientY;
          }, { passive: true });
          swipeArea.addEventListener('touchend', (event) => {
            const deltaX = event.changedTouches[0].clientX - touchStartX;
            const deltaY = event.changedTouches[0].clientY - touchStartY;
            if (Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
              this.changeSelectedDay(deltaX < 0 ? 1 : -1);
            }
          }, { passive: true });
        }
        this.querySelectorAll('[data-action="previous"]').forEach((button) => button.addEventListener('click', () => this.changeMonth(-1)));
        this.querySelectorAll('[data-action="next"]').forEach((button) => button.addEventListener('click', () => this.changeMonth(1)));
        this.querySelectorAll('[data-action="today"]').forEach((button) => button.addEventListener('click', () => {
          this.viewDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
          this.selectedDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
          this.render();
        }));
        this.querySelectorAll('[data-action="close"]').forEach((button) => button.addEventListener('click', () => this.closeModal()));
        this.querySelector('[data-action="ics"]')?.addEventListener('click', () => {
          const event = this.eventFromModal();
          if (event) this.downloadIcs(event);
        });
        this.querySelector('[data-action="copy"]')?.addEventListener('click', async (clickEvent) => {
          const event = this.eventFromModal();
          if (!event) return;
          const url = this.googleCalendarUrl(event);
          await navigator.clipboard.writeText(url);
          clickEvent.currentTarget.textContent = this.labels.copied;
        });
        this.removeEventListener('keydown', this.handleKeydown);
        this.addEventListener('keydown', this.handleKeydown);
      }

      handleKeydown = (event) => {
        if (event.key === 'Escape') this.closeModal();
      };

      eventFromModal() {
        const id = this.querySelector('.release-calendar__modal')?.dataset.eventId;
        return this.events.find((event) => event.id === id);
      }

      changeMonth(amount) {
        this.viewDate = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + amount, 1);
        if (this.viewDate < this.loadedStart || this.viewDate > this.loadedEnd) {
          this.loadEvents(this.viewDate);
        } else {
          this.render();
        }
      }

      changeSelectedDay(amount) {
        const nextDate = new Date(this.selectedDate);
        nextDate.setDate(nextDate.getDate() + amount);
        this.selectedDate = nextDate;
        this.viewDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), 1);
        if (nextDate < this.loadedStart || nextDate >= this.loadedEnd) {
          this.loadEvents(this.viewDate);
        } else {
          this.render();
        }
      }

      filteredEvents() {
        if (this.activeCategory === 'all') return this.events;
        return this.events.filter((event) => event.category === this.activeCategory);
      }

      eventsForDate(date) {
        return this.filteredEvents().filter((event) => {
          if (event.allDay) return this.dateKey(event.start) === this.dateKey(date);
          return this.sameDay(event.start, date);
        });
      }

      sameDay(a, b) {
        return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
      }

      dateKey(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      dateFromKey(key) {
        const [year, month, day] = key.split('-').map(Number);
        return new Date(year, month - 1, day);
      }

      longDate(event) {
        return new Intl.DateTimeFormat(undefined, {
          weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
          ...(event.allDay ? {} : { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })
        }).format(event.start);
      }

      googleCalendarUrl(event) {
        const params = new URLSearchParams({
          action: 'TEMPLATE',
          text: event.title,
          dates: this.calendarDateRange(event),
          details: this.eventDetails(event),
          location: event.location,
          ctz: this.dataset.timeZone
        });
        return `https://calendar.google.com/calendar/render?${params}`;
      }

      eventDetails(event) {
        const productLines = event.products.map((product) => `${product.title || 'Product'}: ${product.url}`);
        return [
          event.description,
          productLines.length ? `${this.labels.productsHeading}:\n${productLines.join('\n')}` : '',
          event.collection ? `${this.labels.viewCollection}: ${event.collection.url}` : ''
        ].filter(Boolean).join('\n\n');
      }

      calendarDateRange(event) {
        if (event.allDay) {
          return `${event.startRaw.replaceAll('-', '')}/${event.endRaw.replaceAll('-', '')}`;
        }
        return `${this.utcStamp(event.start)}/${this.utcStamp(event.end)}`;
      }

      utcStamp(date) {
        return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      }

      downloadIcs(event) {
        const escapeIcs = (value = '') => value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
        const start = event.allDay ? `DTSTART;VALUE=DATE:${event.startRaw.replaceAll('-', '')}` : `DTSTART:${this.utcStamp(event.start)}`;
        const end = event.allDay ? `DTEND;VALUE=DATE:${event.endRaw.replaceAll('-', '')}` : `DTEND:${this.utcStamp(event.end)}`;
        const ics = [
          'BEGIN:VCALENDAR', 'VERSION:2.0', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
          'PRODID:-//Another Round Disc Golf//Release Calendar//EN', 'BEGIN:VEVENT',
          `UID:${escapeIcs(event.uid)}`, `DTSTAMP:${this.utcStamp(new Date())}`, start, end,
          `SUMMARY:${escapeIcs(event.title)}`,
          `DESCRIPTION:${escapeIcs(this.eventDetails(event))}`,
          `LOCATION:${escapeIcs(event.location)}`,
          event.collection ? `URL:${escapeIcs(event.collection.url)}` : '',
          'BEGIN:VALARM', 'TRIGGER:-PT1H', 'ACTION:DISPLAY', `DESCRIPTION:${escapeIcs(event.title)}`,
          'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'
        ].filter(Boolean).join('\r\n');
        const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${event.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'release'}.ics`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(link.href);
      }

      async hydrateProducts() {
        const candidates = this.events.flatMap((event) =>
          event.products.map((product) => ({ event, product }))
        ).filter(({ product }) => this.isLocalProductUrl(product.url));
        await Promise.all(candidates.slice(0, 60).map(async ({ event, product }) => {
          try {
            const url = new URL(product.url, window.location.origin);
            const handle = url.pathname.match(/\/products\/([^/?#]+)/)?.[1];
            if (!handle) return;
            if (!this.productImages.has(handle)) {
              const response = await fetch(`/products/${handle}.js`);
              if (!response.ok) return;
              const productData = await response.json();
              this.productImages.set(handle, {
                title: productData.title || '',
                imageUrl: productData.featured_image || productData.images?.[0] || ''
              });
            }
            const productData = this.productImages.get(handle);
            product.title = productData.title || product.title;
            product.imageUrl = productData.imageUrl;
            if (!event.imageUrl && this.dataset.showImages === 'true') event.imageUrl = product.imageUrl;
          } catch (error) {
            console.debug('[Release calendar] Product details unavailable', error);
          }
        }));
        await this.hydrateCollections();
        this.hydrateBrandLogos();
        this.render();
      }

      hydrateBrandLogos() {
        if (this.dataset.showImages !== 'true') return;
        for (const event of this.events) {
          if (event.imageUrl) continue;
          const brand = this.brandLogos.find((logo) => {
            const name = logo.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            return new RegExp(`(^|[^a-z0-9])${name}([^a-z0-9]|$)`, 'i').test(event.title);
          });
          if (brand) {
            event.imageUrl = brand.image;
            event.brandLogo = true;
          }
        }
      }

      async hydrateCollections() {
        if (this.dataset.showImages !== 'true') return;
        const events = this.events.filter((event) =>
          event.collection && !event.imageUrl && this.isLocalCollectionUrl(event.collection.url)
        );
        await Promise.all(events.slice(0, 20).map(async (event) => {
          try {
            const url = new URL(event.collection.url, window.location.origin);
            const collectionPath = `${url.pathname}${url.search}`;
            if (!url.pathname.match(/\/collections\/[^/?#]+/)) return;
            if (!this.collectionImages.has(collectionPath)) {
              const collectionResponse = await fetch(collectionPath);
              if (!collectionResponse.ok) return;
              const collectionHtml = await collectionResponse.text();
              const collectionDocument = new DOMParser().parseFromString(collectionHtml, 'text/html');
              const main = collectionDocument.querySelector('#MainContent, main') || collectionDocument;
              const productAnchor = main.querySelector('a[href*="/products/"]');
              const productHandle = productAnchor?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
              if (!productHandle) return;

              if (!this.productImages.has(productHandle)) {
                const productResponse = await fetch(`/products/${productHandle}.js`);
                if (!productResponse.ok) return;
                const productData = await productResponse.json();
                this.productImages.set(productHandle, {
                  title: productData.title || '',
                  imageUrl: productData.featured_image || productData.images?.[0] || ''
                });
              }
              const imageUrl = this.productImages.get(productHandle)?.imageUrl || '';
              this.collectionImages.set(collectionPath, imageUrl);
            }
            event.imageUrl = this.collectionImages.get(collectionPath) || '';
            event.collection.imageUrl = event.imageUrl;
          } catch (error) {
            console.debug('[Release calendar] Collection image unavailable', error);
          }
        }));
      }

      isLocalProductUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return url.pathname.includes('/products/');
        } catch (error) {
          return false;
        }
      }

      isLocalCollectionUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return url.pathname.includes('/collections/');
        } catch (error) {
          return false;
        }
      }

      chevron(direction) {
        const path = direction === 'left' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6';
        return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="${path}"/></svg>`;
      }

      escape(value = '') {
        const div = document.createElement('div');
        div.textContent = String(value);
        return div.innerHTML;
      }
    }

    customElements.define('release-calendar', ReleaseCalendar);
  }

  } catch(e) { console.error(e); }
})();
})();
